<template>
  <div class="pt-30 pb-30 mb-60 mb-mb-50 bg-blue-300">
    <div class='container'>
      <div class='flex justify-between items-center flex-wrap tl-db'>
        <div class='pr-20 tb-pr-0'>
          <Breadcrumbs :breadcrumbs='breadcrumbs' />
          <template v-if='hasTitle'>
            <h1 class="fs-36 mb-fs-28 fw-900 mt-12 ttc"><slot name='left-banner'></slot></h1>
          </template>
          <template v-else>
            <slot name='left-banner'></slot>
          </template>
          <slot></slot>
        </div>
        <div>
          <slot name='right-banner'></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '~/components/ui/breadcrumbs/Breadcrumbs'
export default {
  name: 'BannerWithBreadcrumbs2',
  components: { Breadcrumbs },
  props: {
    breadcrumbs: { type: Array },
    hasTitle: { type: Boolean, default: true}
  }
}
</script>

<style scoped>

</style>
